"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iCopyProject = exports.iProjectMetadata = exports.iUpdatePermission = exports.iFolderNotificationsMap = exports.iFolderPermission = exports.iExtendedProject = exports.iProject = exports.iCreateProject = exports.iSortingAndPaginationAPI = exports.iSortingAndPagination = exports.iProjectListFilterColumnValue = exports.iColumnValues = exports.iProjectType = exports.iProjectStatusOrType = void 0;
const t = require("io-ts");
const User = require("./user");
const UserGroup = require("./userGroup");
const Generic = require("./generic");
const customer_1 = require("./customer");
const BillingInformation = require("./billingInformation");
const feature_1 = require("./feature");
const preview_1 = require("./preview");
const customMeta_1 = require("./customMeta");
// Project
exports.iProjectStatusOrType = t.intersection([
    t.interface({
        id: t.number,
        uuid: t.string,
        name: t.string
    }),
    t.partial({
        inUse: t.boolean
    })
]);
exports.iProjectType = t.keyof({
    DRAFT_PROJECT: null,
    PROJECT: null
});
const projectRequired = {
    name: t.string,
    projectStatus: t.union([exports.iProjectStatusOrType, t.null]),
    projectType: t.union([exports.iProjectStatusOrType, t.null])
};
const projectPartials = {
    cover: t.string,
    description: t.string,
    customerId: t.number,
    printProvider: t.number,
    hasNotes: t.boolean,
    notes: t.string,
    projectAdmins: t.array(t.string),
    customerName: t.string
};
exports.iColumnValues = t.keyof({
    id: null,
    name: null,
    company: null,
    description: null,
    status: null
});
exports.iProjectListFilterColumnValue = t.dictionary(exports.iColumnValues, t.string);
const _iSortingAndPagination = t.intersection([
    t.interface({
        sortBy: t.string,
        order: Generic.iOrder
    }),
    Generic.iLimitAndOffsetFront,
    t.partial({
        filter: t.union([t.literal('archived'), t.literal('bookmarked')]),
        columnFilters: exports.iProjectListFilterColumnValue
    })
]);
exports.iSortingAndPagination = t.clean(_iSortingAndPagination);
// We have the api sortingAndPagination also here to make sure front and back are somewhat in sync
const _iSortingAndPaginationAPI = t.intersection([
    t.interface({
        sortBy: t.string,
        order: Generic.iOrder
    }),
    Generic.iLimitAndOffsetApi,
    t.partial({
        filter: t.union([t.literal('archived'), t.literal('bookmarked')]),
        columnFilters: exports.iProjectListFilterColumnValue
    })
]);
exports.iSortingAndPaginationAPI = t.clean(_iSortingAndPaginationAPI);
const createProjectRequired = {
    name: t.string,
    projectStatus: exports.iProjectStatusOrType,
    projectType: exports.iProjectStatusOrType,
    customerUuid: t.string,
};
const createProjectPartials = {
    cover: t.string,
    description: t.string,
    printProvider: t.number,
    salesRepresentive: User.iAuthor,
    notes: t.string,
    customerName: t.string
};
const _iCreateProject = t.intersection([
    t.interface(createProjectRequired),
    t.partial(createProjectPartials),
    t.interface({
        billingInformations: t.array(BillingInformation.iInternalBillingInformation),
        notifyFollowing: t.array(t.string),
        features: t.array(feature_1.iFeature),
        conversionService: preview_1.iConversionService,
        template: t.boolean
    }),
    t.partial({
        id: t.number,
        projectId: t.number,
    })
]);
exports.iCreateProject = t.clean(_iCreateProject);
const _iProject = t.intersection([
    t.interface({
        type: exports.iProjectType,
        id: t.number,
        projectId: t.number,
        uuid: t.string,
        rootFolderIdentifier: t.string,
        rootFolder: t.number,
        bookmarked: t.boolean,
        updatedAt: t.number,
        visitedAt: t.union([t.number, t.null]),
        perm: t.number,
        showPartiesTab: t.boolean,
        template: t.boolean
    }),
    t.interface(projectRequired),
    t.partial(projectPartials),
    t.partial({
        author: User.iAuthor,
        createdAt: t.number,
        deletedAt: t.number,
    })
]);
exports.iProject = t.clean(_iProject);
// Extended project is only for admin routes
const _iExtendedProject = t.intersection([
    exports.iProject,
    t.interface({
        customer: customer_1.iCustomer,
        billingInformations: t.array(BillingInformation.iInternalBillingInformation),
        notifyFollowing: t.array(t.string),
        conversionService: preview_1.iConversionService
    }),
    t.partial({
        customerSalesRepresentative: User.iAuthor,
        salesRepresentive: User.iAuthor,
        author: User.iAuthor
    })
]);
exports.iExtendedProject = t.clean(_iExtendedProject);
exports.iFolderPermission = t.interface({
    folder: t.string,
    group: t.string,
    type: t.union([t.literal('NormalUserGroup'), t.literal('CustomerUserGroup')]),
    permissions: t.number
});
exports.iFolderNotificationsMap = t.dictionary(t.string, t.array(UserGroup._Notifications));
exports.iUpdatePermission = t.interface({
    folder: t.string,
    group: t.string,
    includeSubFolders: t.boolean,
    permission: t.number
});
exports.iProjectMetadata = t.interface({
    id: t.number,
    project_id: t.number,
    metadata: t.array(customMeta_1.iMetadata),
    created_at: t.union([t.null, t.number]),
    updated_at: t.union([t.null, t.number]),
    deleted_at: t.union([t.null, t.number])
});
exports.iCopyProject = t.union([
    t.interface({
        type: t.literal('TEMPLATE'),
        copyFrom: t.number,
        projectName: t.string,
        projectDescription: t.string,
        folderStructure: t.boolean,
        files: t.boolean,
        userGroups: t.boolean,
        users: t.boolean
    }),
    t.interface({
        type: t.literal('COPY'),
        copyFrom: t.number,
        selectedCompanyId: t.number,
        projectName: t.string,
        folderStructure: t.boolean,
        files: t.boolean,
        userGroups: t.boolean,
        users: t.boolean
    })
]);
//# sourceMappingURL=project.js.map